import { render, staticRenderFns } from "./Liangqin.vue?vue&type=template&id=46f45b82&scoped=true"
import script from "./Liangqin.vue?vue&type=script&lang=js"
export * from "./Liangqin.vue?vue&type=script&lang=js"
import style0 from "./Liangqin.vue?vue&type=style&index=0&id=46f45b82&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f45b82",
  null
  
)

export default component.exports